import React, {useState, useEffect} from 'react'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import ArrowDown from '../../assets/icons/ArrowDown'
import FilterList from './FilterList'
import FilterSvg from '../../assets/icons/FilterSvg'
import { useDispatch, useSelector } from 'react-redux'
import { getCategories } from '../../services/actions/MainAction'

function MainFilter({subCategoryId="",setSubCategoryId=()=>{}, setCategoryId=()=>{}, categoryId=""}) {
  const [visible, setVisible] = useState(true);
  const contentData = useSelector(state => state.Data.contentData);
  const categoresData = useSelector(state => state.Data.categoresData);
  const lang_id = useSelector(state => state.Data.lang_id);
  const dispatch = useDispatch()
  useEffect(()=>{
    window.addEventListener("resize", (e)=>{
      if(window.innerWidth>=1000){
        setVisible(true)
      }else{
        setVisible(false)
      }
    })
    if(window.innerWidth>=1000){
      setVisible(true)
    }else{
      setVisible(false)
    }
  },[]);


  return (
    <div className="w-[355px] min-w-[355px] max-[1000px]:px-[20px] max-[1000px]:w-full max-[400px]:w-full max-[400px]:min-w-full">
      <div className='w-[355px] min-w-[355px] bg-white border border-gray-200 rounded-[10px] p-[20px] max-[1000px]:min-w-full max-[1000px]:w-full max-[400px]:w-full max-[400px]:min-w-full'>
          <div className="flex items-center justify-between">
            <h2 className='text-[22px] font-[600]'>{contentData?.product_filter}</h2>
            <button onClick={()=>setVisible(!visible)} className="hidden max-[1000px]:inline">
              <FilterSvg />
            </button>
          </div>
          {
            visible?
            <ul className='flex flex-col gap-[10px] mt-[20px]'>
              {
                categoryId !==""?
                <FilterList subCategoryId={subCategoryId} setSubCategoryId={(id)=>setSubCategoryId(id)} setCategoryId={(id)=>setCategoryId(id)}  data={{translate:{title: contentData?.show_all}, id:""}} type="button" />:null
              }
              {
                categoresData?.map((data, i) =>{
                  return(
                    <FilterList subCategoryId={subCategoryId} setSubCategoryId={(id)=>setSubCategoryId(id)} categoryId={categoryId} setCategoryId={(id)=>setCategoryId(id)} key={i} data={data} type="button" />
                  )
                })
              }
            </ul>:null
          }
          
      </div>
    </div>
  )
}

export default MainFilter
